/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_DRUGS_THERAPEUTIC_CLASS_DISPLAY =
  'REFRESH_DRUGS_THERAPEUTIC_CLASS_DISPLAY';
export const DISPATCH_DRUGS_THERAPEUTIC_CLASS =
  'DISPATCH_DRUGS_THERAPEUTIC_CLASS';
export const DISPATCH_DRUGS_THERAPEUTIC_CLASS_PROCCESS =
  'DISPATCH_DRUGS_THERAPEUTIC_CLASS_PROCCESS';
export const DISPATCH_DRUGS_THERAPEUTIC_CLASS_REPORT =
  'DISPATCH_DRUGS_THERAPEUTIC_CLASS_REPORT';
export const SET_SELECTED_INPUT = 'SET_SELECTED_INPUT';
export const IS_LOADING = 'IS_LOADING';
export const REFRESH_DRUGS_THERAPEUTIC_CLASS =
  'REFRESH_DRUGS_THERAPEUTIC_CLASS';
export const GET_ERROR_MSG_NDC_DETAILS = 'GET_ERROR_MSG_NDC_DETAILS';
